import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-12" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex items-center pr-1.5" }
const _hoisted_4 = { class: "text-xl font-bold text-gray-900 px-1 truncate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "bg-white border rounded loadingEl h-[200px]"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-white border rounded flex flex-col min-h-[200px]"
}

import { PlusIcon } from "@heroicons/vue/24/solid";
import { computed, ref } from "vue";
import { useHasOrganizationPermission } from "shared/composables/organization";
import { Organization } from "shared/types/Organization";
import { User } from "shared/types/User";
import InviteUsersModal from "@/components/users/InviteUsersModal.vue";
import { useUsersForOrganization } from "@/composables/user";
import OrganizationTabUsersHierarchyItem from "@/views/organizations/components/OrganizationTabUsersHierarchyItem.vue";
import OrganizationTabUsersList from "@/views/organizations/components/OrganizationTabUsersList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabUsers',
  props: {
    organization: {},
    organizationsByParentId: {}
  },
  setup(__props: any) {

const props = __props;

const isInviteUsersModalOpen = ref(false);

const hasOrganizationAdminPermission = useHasOrganizationPermission(
  "organization_admin",
  props.organization._id,
);

const { users, isFetching } = useUsersForOrganization(computed(() => props.organization._id));

const childOrganizations = computed(
  () => props.organizationsByParentId[props.organization._id] || [],
);

const usersByOrganizationId = computed(() =>
  users.value.reduce((acc, user) => {
    for (const organization of user.organizations) {
      if (organization.explicit_groups.length > 0) {
        if (!acc[organization.organization_id]) {
          acc[organization.organization_id] = [];
        }
        (acc[organization.organization_id] as User[]).push(user);
      }
    }
    return acc;
  }, {} as Record<string, User[] | undefined>),
);

const usersForOrganization = computed(
  () => usersByOrganizationId.value[props.organization._id] || [],
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("organizations.users")), 1),
        _hoisted_5,
        (_unref(hasOrganizationAdminPermission))
          ? (_openBlock(), _createBlock(_unref(PlusIcon), {
              key: 0,
              class: "w-5 h-5 cursor-pointer text-gray-600 shrink-0",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isInviteUsersModalOpen.value = true), ["stop"]))
            }))
          : _createCommentVNode("", true)
      ]),
      (_unref(isFetching))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("", true),
      (!_unref(isFetching))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(OrganizationTabUsersList, {
              users: usersForOrganization.value,
              organization: _ctx.organization,
              canEdit: _unref(hasOrganizationAdminPermission),
              hideNoUsersMessage: childOrganizations.value.length > 0
            }, null, 8, ["users", "organization", "canEdit", "hideNoUsersMessage"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childOrganizations.value, (childOrganization, index) => {
              return (_openBlock(), _createBlock(OrganizationTabUsersHierarchyItem, {
                key: childOrganization._id,
                organization: childOrganization,
                organizationsByParentId: _ctx.organizationsByParentId,
                usersByOrganizationId: usersByOrganizationId.value,
                canEdit: _unref(hasOrganizationAdminPermission),
                hideFirstTopBorder: index === 0 && usersForOrganization.value.length === 0
              }, null, 8, ["organization", "organizationsByParentId", "usersByOrganizationId", "canEdit", "hideFirstTopBorder"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (isInviteUsersModalOpen.value)
      ? (_openBlock(), _createBlock(InviteUsersModal, {
          key: 0,
          existingUsers: usersForOrganization.value,
          organizationId: _ctx.organization._id,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isInviteUsersModalOpen.value = false))
        }, null, 8, ["existingUsers", "organizationId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})